export default __webpack_public_path__ + "assets/imgView.4d977c45.png";